<template>
  <el-main>
    <el-card shadow="never">
      <div style="display:flex; flex-flow: row; margin: 30px 10px;">
        <div class="title">
          <div style="max-height: 60px; max-width: 60px;">
            <div v-if="aplicacaoTitle.image" class="mosiaLogo" style="max-height: 100%; max-width: 100%;">
              <img :src="aplicacaoTitle.image" alt="icon" style="max-height: 100%; max-width: 100%;"/>
            </div>
            <div v-else class="mosiaLogo" style="max-height: 100%; max-width: 100%;">
              <i class="material-symbols-rounded fill" style="font-size: 40px;">{{ aplicacaoTitle.icon }}</i>
              </div>
          </div>
          <div>
            <h1 v-if="aplicacaoTitle">{{ aplicacaoTitle.name }}</h1>
            <h3 v-if="aplicacaoTitle">{{ aplicacaoTitle.applicationName }}</h3>
          </div>
        </div>
        <div class="search-input">
          <el-input
            ref="inputSearch"
            placeholder="Pesquisar Configuração"
            :prefix-icon="!searchText ? 'el-icon-search' : ''"
            size="medium"
            v-model="searchText"
            :clearable=true
          />
        </div>
      </div>
      <navbar-card
        :menus="menuSearched"
      />
    </el-card>
  </el-main>
</template>

<script>
import { mapState } from 'vuex'
import NavbarCard from '@/components/shared/navbar/navbar-card-dashboards/navbar-card.vue'
export default {
  name: 'HomeAplications',
  components: {
    NavbarCard
  },
  data () {
    return {
      searchText: '',
      searchResult: null
    }
  },
  computed: {
    ...mapState([
      'menus'
    ]),
    ...mapState('login', [
      'usuario',
      'permissaoRouter',
      'operadora'
    ]),
    ...mapState('SelecionaAplicacao', ['aplicacoes']),
    menusFlitrados () {
      if (Array.isArray(this.permissaoRouter) && this.permissaoRouter.length > 0) {
        return this.menus.map(menu => {
          return {
            ...menu,
            childs: menu.childs.filter(child => this.permissaoRouter.includes(child.routerName))
          }
        })
      }
      return this.menus
    },
    nomeUsuario () {
      return this.usuario.nome
    },
    idConfigClienteApp () {
      return this.$route.params.idConfigClienteApp || ''
    },
    aplicacao () {
      if (!this.idConfigClienteApp) {
        return null
      }
      return this.aplicacoes.find(
        app => `${app.id_cliente_app}` === this.idConfigClienteApp
      ) || null
    },
    aplicacaoTitle () {
      if (!this.aplicacao) {
        return {
          name: 'Configurações globais',
          applicationName: '',
          icon: 'settings'
        }
      }
      return {
        name: this.aplicacao.descricao,
        applicationName: this.aplicacao.descricao_app,
        image: this.aplicacao.icon
      }
    },
    queryGroup () {
      return this.$route.query.group || ''
    },
    menuSearched () {
      let menusFiltered = [...this.menusFlitrados]

      if (this.aplicacao) {
        menusFiltered = menusFiltered.map(menu => ({
          ...menu,
          childs: menu.childs.filter(child => child.tipoAplicacao.includes(this.aplicacao.tipo_aplicacao))
        })).filter(menu => menu.childs.length > 0)
      } else {
        menusFiltered = menusFiltered.map(menu => ({
          ...menu,
          childs: menu.childs.filter(child => child.tipoAplicacao.length === 0)
        })).filter(menu => menu.childs.length > 0)
      }

      if (this.queryGroup !== '' && this.queryGroup !== 'Home') {
        menusFiltered = menusFiltered.filter(menu => menu.routerName === this.queryGroup)
      }

      if (this.searchText !== '') {
        const menuChilds = this.__concatChilds(menusFiltered)
        const filteredMenusChildren = menuChilds.filter(menu => menu.name.toLowerCase().includes(this.searchText.toLowerCase()))
        menusFiltered = (filteredMenusChildren.length > 0) ? this.__mounteMenu(filteredMenusChildren) : this.__mounteEmptyMenu()
      }

      return menusFiltered
    }
  },
  methods: {
    __mounteMenu (menu) {
      return [{
        childs: [ ...menu ],
        icon: 'search',
        title: `${menu.length} ${menu.length > 1 ? 'resultados' : 'resultado'}`,
        routerName: null,
        showNavCardDash: true
      }]
    },
    __mounteEmptyMenu () {
      return [{
        childs: [],
        icon: 'search',
        title: 'Nenhum resultado encontrado',
        routerName: null,
        showNavCardDash: true
      }]
    },
    __getChilds (menu) {
      return menu.childs.map(child => {
        return {
          ...child,
          icon: menu.icon,
          parent: {
            title: menu.title,
            routerName: menu.routerName
          }
        }
      })
    },
    __concatChilds (menus) {
      return menus.reduce((acc, menu) => {
        return acc.concat(this.__getChilds(menu))
      }, [])
    }
  },
  mounted () {
    document.addEventListener('keydown', event => {
      if (event.ctrlKey && event.shiftKey && event.key === 'F') {
        this.$refs.inputSearch.focus()
        event.preventDefault()
      }
      if (event.key === 'Escape') {
        this.$refs.inputSearch.blur()
        this.searchText = ''
        this.searchResult = null
      }
    })
  },
  beforeDestroy () {
    document.removeEventListener('keydown', event => {
      if (event.ctrlKey && event.shiftKey && event.key === 'F') {
        this.$refs.inputSearch.focus()
        event.preventDefault()
      }
      if (event.key === 'Escape') {
        this.$refs.inputSearch.blur()
        this.searchText = ''
        this.searchResult = null
      }
    })
  }
}
</script>
<style lang="less">
.search-input {
  width: 381px;
  text-align: center;
  .el-input {
    width: 381px;
    text-align: center;
    font: normal normal normal 18px/24px Open Sans;
    .el-input__inner {
      background: #E5F1FD 0 0 no-repeat padding-box;
      border-radius: 50px;
      color: #5D8CBA;
      border: none;
    }
    ::placeholder {
      text-align: center;
      color: #5D8CBA;
    }
    :active, :focus {
      border: 1px solid #5D8CBA;
    }
    .el-input__suffix{
      color: #5D8CBA;
      right: 15px;
    }
    :active, :focus {
      border: none;
    }
  }
}

</style>
<style scoped lang="less">
.title {
  width: 100%;
  display: flex;
  flex-flow: row;
  column-gap: 15px;
}
.title h1{
  font-family: "Open Sans", sans-serif;
  font-size: 26px;
  text-transform: capitalize;
}
.title h3{
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #555555;
}

.fill {
  font-variation-settings: 'FILL' 1;
  color: #5D8CBA;
}
</style>
